import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

// Days: 0 = Sunday, 1 = Monday, ..., 6 = Saturday
const WEEKDAYS = [1, 2, 3, 4, 5]; // Mon-Fri
const WEEKEND = [0, 6]; // Sat-Sun
const EVERYDAY = [0, 1, 2, 3, 4, 5, 6];

interface DayQuickSelectProps {
  selectedDays: number[];
  onDaysChange: (days: number[]) => void;
  className?: string;
}

export function DayQuickSelect({
  selectedDays,
  onDaysChange,
  className,
}: DayQuickSelectProps) {
  const { t } = useTranslation('staff');

  const arraysEqual = (a: number[], b: number[]) => {
    if (a.length !== b.length) return false;
    const sortedA = [...a].sort();
    const sortedB = [...b].sort();
    return sortedA.every((val, i) => val === sortedB[i]);
  };

  const presets = [
    {
      label: t('availability.wizard.presets.weekdays', 'Weekdays'),
      days: WEEKDAYS,
      active: arraysEqual(selectedDays, WEEKDAYS),
    },
    {
      label: t('availability.wizard.presets.weekend', 'Weekend'),
      days: WEEKEND,
      active: arraysEqual(selectedDays, WEEKEND),
    },
    {
      label: t('availability.wizard.presets.everyday', 'Every day'),
      days: EVERYDAY,
      active: arraysEqual(selectedDays, EVERYDAY),
    },
  ];

  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {presets.map((preset) => (
        <button
          key={preset.label}
          type="button"
          onClick={() => onDaysChange(preset.days)}
          className={cn(
            'px-4 py-2 text-sm font-medium rounded-lg border transition-colors tap-highlight-transparent',
            'active:scale-[0.98]',
            preset.active
              ? 'bg-blue-100 border-blue-300 text-blue-700'
              : 'bg-white border-gray-200 text-gray-600 hover:border-gray-300 active:bg-gray-50'
          )}
        >
          {preset.label}
        </button>
      ))}
    </div>
  );
}
